import { Component } from "@angular/core";

@Component({
    templateUrl: "http-404.component.html",
    styleUrls: ["http-404.component.scss"],
})
export class Http404Component {}
